import type { AIRecord } from "@/types";

export interface TopicTitleChange {
    topicNo: string;
    title: string;
}

export function getTopicTitleChange(payload: unknown): TopicTitleChange | null {
    if (!payload || typeof payload !== "object") return null;

    const { topicNo, title } = payload as Partial<TopicTitleChange>;
    const normalizedTopicNo = topicNo?.trim();
    const normalizedTitle = title?.trim();

    if (!normalizedTopicNo || !normalizedTitle) return null;

    return {
        topicNo: normalizedTopicNo,
        title: normalizedTitle,
    };
}

export function applyTopicTitleUpdate(
    history: AIRecord,
    change: TopicTitleChange | null
): AIRecord {
    if (!change) return history;

    return {
        ...history,
        content: history.content.map(record =>
            record.topicNo === change.topicNo
                ? { ...record, topicName: change.title }
                : record
        ),
    };
}
